import { writable } from "svelte/store";

export const currentGoBack = writable(null);

export const accountInfo = writable(null);
export const jwt_token = writable(null);
export const fcm_token = writable("");

// 초기값 세팅
export const initialFilter = {
    startDate: "",
    endDate: "",
    is_status: "1",
    ASGN_EMPNO: "1",
    dataList: [],
    currentList: [],
    currentPage: 0,
    scrollTop: 0,
    keyword: "",
};

// 세션 스토리지에서 기존 데이터 로드
const saved = sessionStorage.getItem("asFilter");
export const asFilter = writable(saved ? JSON.parse(saved) : initialFilter);

// 값이 바뀔 때마다 세션 스토리지에 저장
asFilter.subscribe((value) => {
    sessionStorage.setItem("asFilter", JSON.stringify(value));
});

const defaultToday = new Date();
const defaultSixMonthsAgo = new Date();
defaultSixMonthsAgo.setMonth(defaultToday.getMonth() - 6);

// 검사관리 주내역 필터 및 스크롤 보존용 스토어
export const initialInspectFilter = {
    as_wrkshp_code: "2023020001",
    as_plan_se: "%",
    ad_plan_sde: defaultSixMonthsAgo.toISOString().split("T")[0],
    ad_plan_ede: defaultToday.toISOString().split("T")[0],
    is_clos_at: true,
    as_qltinsp_se: "A",
    fullDataList: [],
    visibleList: [],
    displayedCount: 30,
    scrollTop: 0,
    isSummaryExpanded: false,
};

const savedInspect = sessionStorage.getItem("inspectFilter");
export const inspectFilter = writable(savedInspect ? JSON.parse(savedInspect) : initialInspectFilter);

inspectFilter.subscribe((value) => {
    sessionStorage.setItem("inspectFilter", JSON.stringify(value));
});
